export {
  Card,
  CardBody,
  CardFooter,
  CardFooterRow,
  CardFooterColumn,
  Tag,
  Price,
  CardDetail,
  CardDetailImage,
  CardActionButton,
} from './style';



// WEBPACK FOOTER //
// ./src/components/card/index.js